import { useState, useEffect } from "react";
import { useAgentInstructions } from "../contexts/AgentInstructionsContext";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { parseMarkdownToMKPro } from "utils/markdownParser";

function AgentInfo() {
  const { agentNumber, agentName, agentSummary, loading } = useAgentInstructions();
  const [parsedSummary, setParsedSummary] = useState([]);

  useEffect(() => {
    const parsed = parseMarkdownToMKPro(agentSummary);
    setParsedSummary(parsed);
  }, [agentSummary]);

  if (loading) {
    return (
      <MKBox component="section" py={12}>
        <Container>
          <MKBox display="flex" justifyContent="center" alignItems="center" height="400px">
            <CircularProgress size={100} />
          </MKBox>
        </Container>
      </MKBox>
    );
  }

  return (
    <MKBox component="section" py={12} px={1}>
      <Container>
        <Grid container item xs={12} lg={8}>
          <MKTypography variant="h3">
            Agent {agentNumber}: {agentName}
          </MKTypography>
          {parsedSummary}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default AgentInfo;
